// THE BOT DRIVER (Matt, 2026-10-12: "a play test mode where I could do it solo
// and play with some bots... just focus on one player's experience"). The
// roles nobody claimed are held by bots (engine/game.js isBot); this plays
// their days, one move at a time and slowly enough to follow on the table,
// from ONE screen only: the host's (the phone or TV that opened the room),
// or this phone in a game with no room. Same bots as tools/playtest.
import { civFor, dispatch, doneAction, isBot } from '@/engine/game';
import { PHASES, ROLES } from '@/engine/constants';
import { MOVES, needs } from './bots';

const PACE_MS = 1300;
const MAX_MOVES = 40;

/**
 * The next thing a bot does today, or null when every bot is done. `count`
 * (moves so far, by round and role) is the guard against a bot that spins.
 */
export const nextBotAction = (game, count = {}) => {
  if (game?.meta?.phase !== PHASES.DAY) return null;
  const role = ROLES.find((r) => isBot(game.roles?.[r]) && !game.done?.[r]);
  if (!role) return null;
  const key = `${game.meta.round}:${role}`;
  if ((count[key] || 0) >= MAX_MOVES) return doneAction(role);
  const civ = civFor(game, role);
  const move = MOVES[role](game, needs(civ, game.meta), 'balanced', game.meta);
  // A move the reducer would refuse is the end of that bot's day.
  if (!move || dispatch(game, move) === game) return doneAction(role);
  count[key] = (count[key] || 0) + 1;
  return move;
};

export const botDriver = (store) => {
  let busy = false;
  let timer = null;
  let count = {};
  let day = null;

  const drives = (state) => {
    if (!state.game || state.tutorial || state.mode === 'table' && !state.roomId) return false;
    if (state.roomId) return Boolean(state.user?.uid) && state.roomMeta?.hostUid === state.user.uid;
    return true;
  };

  const next = (game) => nextBotAction(game, count);

  const tick = () => {
    timer = null;
    const { state } = store;
    if (busy || !drives(state) || state.game.meta.phase !== PHASES.DAY) return;
    if (day !== state.game.meta.round) { day = state.game.meta.round; count = {}; }
    const action = next(state.game);
    if (!action) return;
    busy = true;
    Promise.resolve(store.dispatch('play', action)).finally(() => {
      busy = false;
      timer = setTimeout(tick, PACE_MS);
    });
  };

  store.subscribe((mutation) => {
    if (!['setRemoteGame', 'setGame', 'setRoom', 'setRoomMeta', 'setUser'].includes(mutation.type)) return;
    if (!timer && !busy) timer = setTimeout(tick, PACE_MS);
  });
};
